module.exports = __webpack_public_path__ + "static/media/My Rose.9c002ebd.png";